import { useI18n, type Translator } from "~/i18n";
import {
  WorkspaceBreadcrumb,
  WorkspaceBreadcrumbItem,
  WorkspaceBreadcrumbSeparator,
} from "../WorkspaceBreadcrumb";
import { SETTINGS_SECTION_LABELS, settingsSectionLabel, type SettingsPath } from "./settingsSearch";

function settingsBreadcrumbLabel(pathname: string, t: Translator): string | null {
  const normalizedPathname = pathname.replace(/\/+$/, "") || "/";
  if (normalizedPathname === "/settings/diagnostics") {
    return t("settings.section.diagnostics");
  }
  if (normalizedPathname in SETTINGS_SECTION_LABELS) {
    return settingsSectionLabel(normalizedPathname as SettingsPath, t);
  }
  return null;
}

export function SettingsBreadcrumb({ pathname }: { pathname: string }) {
  const { t } = useI18n();
  const sectionLabel = settingsBreadcrumbLabel(pathname, t);

  return (
    <WorkspaceBreadcrumb ariaLabel={t("settings.breadcrumb")}>
      {sectionLabel ? (
        <>
          <WorkspaceBreadcrumbItem>{t("settings.breadcrumb")}</WorkspaceBreadcrumbItem>
          <WorkspaceBreadcrumbSeparator />
        </>
      ) : null}
      <WorkspaceBreadcrumbItem current className="truncate">
        {sectionLabel ?? t("settings.breadcrumb")}
      </WorkspaceBreadcrumbItem>
    </WorkspaceBreadcrumb>
  );
}
